import { useQuery } from "react-query";
import { useApiService } from "../useApiService";
import { QUERY } from "../../constants/query";
import { ProblemControllerService } from "../../services";

// Hook to get all colors
export const useGetAllProblems = () => {
  const { handleRequest } = useApiService();
  const queryKey = [QUERY.GET_ALL_PROBLEMS];

  const query = useQuery(queryKey, () =>
    handleRequest(ProblemControllerService.problemControllerGetAllProblems())
  );

  return {
    ...query,
  };
};
